import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/bthinking/bthinking/src/components/mdx/MDXPageLayout";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-us",
      "style": {
        "position": "relative"
      }
    }}>{`About us`}</h1>
    <p>{`Bridge is a laboratory integrated into the Technological Center (CTC) of the Federal University of Santa Catarina
(UFSC), that works with research and development of technological solutions connecting government and citizen
through innovation.`}</p>
    <p><img parentName="p" {...{
        "src": "/image/team.jpg",
        "alt": "Bridge Team"
      }}></img></p>
    <h2 {...{
      "id": "what-we-value",
      "style": {
        "position": "relative"
      }
    }}>{`What we value`}</h2>
    <p>{`As an organization and individuals, we respect society, as well as employees, partners, the academic community,
customers and all those we impact. We work to achieve results with simplicity, not leaving aside the constant
search for creativity and technological innovation. Our commitment is to contribute positively to society,
always giving value to ethics and transparency in projects. Most importantly, we are passionate and committed to
people and technology. With humility, we take on challenges by encouraging the whole team to work together, to
achieve the highest quality, agility, and excellence.`}</p>
    <h2 {...{
      "id": "our-development-process",
      "style": {
        "position": "relative"
      }
    }}>{`Our development process`}</h2>
    <p>{`We perform an extensive reference search to develop our components and we were inspired by several design systems, mainly the `}<a href="https://www.carbondesignsystem.com/">{`Carbon Design System`}</a>{` and `}<a href="https://atlassian.design/">{`Atlassian Design`}</a>{`, also on the usability recommendations of the `}<a href="https://www.nngroup.com">{` NN Group`}</a>{`.
During the development stages, we also held discussions with developers and business analysts of various products of our laboratory, to cover as many use cases as possible.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      